import { atom } from 'recoil';

import { TGuardianBlockReason } from 'modules/checkout/domain/entities';

export const guardianBlockReason = atom<TGuardianBlockReason | null>({
  key: 'guardianBlockReason',
  default: null,
});
